export default __webpack_public_path__ + "static/media/Vector4.2c884cae.svg";